"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var QuotaBaseRecord = (0, _immutable.Record)({
  id: null,
  quotaType: 'REVENUE',
  currency: null,
  period: null,
  portalId: null,
  startDate: null,
  endDate: null,
  value: null,
  ownerId: null,
  pipelineId: null
}, 'Quota');

var QuotaRecord =
/*#__PURE__*/
function (_QuotaBaseRecord) {
  (0, _inherits2.default)(QuotaRecord, _QuotaBaseRecord);

  function QuotaRecord() {
    (0, _classCallCheck2.default)(this, QuotaRecord);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(QuotaRecord).apply(this, arguments));
  }

  (0, _createClass2.default)(QuotaRecord, [{
    key: "getRowKey",
    value: function getRowKey() {
      return this.ownerId + ":" + this.pipelineId;
    }
  }, {
    key: "getStartMs",
    value: function getStartMs() {
      return this.startDate.valueOf();
    }
  }]);
  return QuotaRecord;
}(QuotaBaseRecord);

exports.default = QuotaRecord;
module.exports = exports.default;